<template>
  <div>
    <nav class="header">
      <div class="header--col">
        <h4 :style="{ color: primary }">
          Superadmin
        </h4>
        <h2>{{ pageTitle }}</h2>
      </div>
      <div class="header--col user--col">
        <div
          v-on-clickaway="handleBodyClick"
          class="user--options"
          @click="handleUserClick"
        >
          <span class="user--name">{{ user.displayName }}</span>
          <div v-if="user.avatar">
            <img :src="user.avatar" :alt="fullName" class="user--avatar" />
          </div>
          <div v-else class="widget--avatar">
            <span>{{ user.firstName[0] }}</span>
          </div>
          <div
            class="user--settings-wrapper"
            :class="showMenu ? 'fade-in' : ''"
          >
            <ul>
              <li>
                <router-link to="/superadmin/profile">
                  <img src="@/assets/media/icons/person.svg" alt="user icon" />
                  <span>Profile</span>
                </router-link>
              </li>
              <li class="btn-logout">
                <a
                  href="javascript:;"
                  :style="{ color: primary }"
                  @click="handleSignout"
                >
                  Sign Out
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { mixin as clickaway } from "vue-clickaway";
import { mapGetters, mapActions } from "vuex";
import authTypes from "@/store/auth/types";

export default {
  name: "Navbar",
  mixins: [clickaway],
  data() {
    return {
      showMenu: false,
      pageTitle: this.$route.params.name
    };
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
    fullName() {
      return this.user.firstName + " " + this.user.lasName;
    },
    primary() {
      return this.$store.state.app.scheme.primary;
    }
  },
  watch: {
    $route(to) {
      if (!to.params.modal) {
        this.pageTitle = to.name
          ? to.name.replace("-", " ")
          : to.matched[1].name
          ? to.matched[1].name.replace("-", " ")
          : to.matched[0].name.replace("-", " ");
        this.changeActiveTrail([
          { name: "Home", link: "/superadmin" },
          {
            name: this.pageTitle
          }
        ]);
      }
    }
  },
  created() {
    this.pageTitle = this.$route.name.replace("-", " ");
    this.changeActiveTrail([
      { name: "Home", link: "/superadmin" },
      {
        name: this.pageTitle
      }
    ]);
  },
  mounted() {},
  methods: {
    ...mapActions({
      changeActiveTrail: "changeActiveTrail",
      [authTypes.AUTH_UNSET]: authTypes.AUTH_UNSET
    }),
    ...mapGetters(["conciergeActivatedTrail"]),
    handleBodyClick() {
      this.showMenu = false;
    },
    handleUserClick() {
      this.showMenu = !this.showMenu;
    },
    handleSignout() {
      this[authTypes.AUTH_UNSET]().then(() => {
        this.$router.push("/");
      });
    }
  }
};
</script>

<style lang="scss" scoped>
/* @import "~@/assets/scss/custom/_variables.scss"; */

nav {
  color: white;
  padding: 40px 30px;
  width: 100%;
  &.header {
    align-items: center;
    display: flex;
    .header--col {
      width: 50%;
      h4 {
        font-weight: 500;
        margin-bottom: 10px;
      }
      h2 {
        color: $gray-900;
        font-size: $h2-font-size;
        font-weight: 500;
        margin-bottom: 10px;
        text-transform: capitalize;
      }
      &.user--col {
        display: flex;
        justify-content: flex-end;
        img {
          border-radius: 50%;
          display: block;
          height: 30px;
          width: 30px;
        }
        .user--options {
          align-items: center;
          background-color: transparent; // use theme
          border-radius: 10px;
          position: relative;
          cursor: pointer;
          display: flex;
          padding: 10px 20px;
          position: relative;
          transition: background-color 0.2s ease;
          &:hover {
            background-color: $brand-secondary; // use theme
          }
          span {
            color: $gray-900;
            font-family: "Gotham Book";
            font-size: $font-size-sm;
            margin-right: 15px;
          }
          .user--settings-wrapper {
            background-color: #fff;
            border-radius: 10px;
            box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.3);
            opacity: 0;
            position: absolute;
            right: 0;
            top: 100%;
            transition: all 0.2s ease-out;
            transform: translateY(-10px);
            width: 200px;
            z-index: -1;
            &.fade-in {
              opacity: 1;
              transform: translateY(0);
              z-index: 5;
            }
            ul {
              margin: 0;
              padding-left: 0;
              padding-top: 12px;
              li {
                a,
                span {
                  align-items: center;
                  color: $gray-900;
                  display: flex;
                  font-family: "Gotham Book";
                  font-size: $font-size-xs;
                  img {
                    height: 13px;
                    margin-right: 15px;
                    width: 13px;
                  }
                }
                &:not(:last-child) {
                  background-color: $white;
                  padding: 12px 20px;
                  transition: background-color 0.2s ease;
                  &:hover {
                    background-color: $brand-secondary;
                  }
                }
                &.btn-logout {
                  background-color: $gray-300;
                  margin-top: 12px;
                  text-align: center;
                  a {
                    color: $brand-primary;
                    display: block;
                    font-family: "Gotham";
                    font-weight: 500;
                    padding-bottom: 12px;
                    padding-top: 12px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
